import type { FlotiqStore } from "@jti/fe-common";

export const getStoreDetailsPageUrl = ({
  storeDetailsPage,
  store,
  defaultZoom,
  isOpeningHoursEnabled,
  isOpeningHoursBreaksEnabled,
  isAvailableDevicesEnabled,
  isAvailableSticksEnabled = false,
  isMultiBrandSticksEnabled = false,
  isGeneralAnnouncementEnabled = false,
  isAvailableServicesEnabled = false,
  isStoreTypeEnabled = false,
  isVendingMachineEnabled = false,
  isVendingMachineTipEnabled = false,
  isNearbyShopsEnabled = false,
  isAsianAddressFormatEnabled = false,
  isSeoFriendlyUrlsEnabled = false,
}: {
  storeDetailsPage?: string;
  store?: FlotiqStore;
  defaultZoom?: number;
  isOpeningHoursEnabled?: boolean;
  isOpeningHoursBreaksEnabled?: boolean;
  isAvailableDevicesEnabled?: boolean;
  isAvailableSticksEnabled?: boolean;
  isMultiBrandSticksEnabled?: boolean;
  isGeneralAnnouncementEnabled?: boolean;
  isAvailableServicesEnabled?: boolean;
  isStoreTypeEnabled?: boolean;
  isVendingMachineEnabled?: boolean;
  isVendingMachineTipEnabled?: boolean;
  isNearbyShopsEnabled?: boolean;
  isAsianAddressFormatEnabled?: boolean;
  isSeoFriendlyUrlsEnabled?: boolean;
}) => {
  if (!storeDetailsPage || !store) {
    return undefined;
  }

  if (isSeoFriendlyUrlsEnabled) {
    if (!store?.State_slug || !store?.City_slug) {
      return undefined;
    }

    return `${storeDetailsPage}/${store?.State_slug}/${store?.City_slug}/${store?.id}`;
  }
  const storeDetailsExtendedParams = {
    shopId: `${store?.id}`,
    ...(defaultZoom && { defaultZoom: `${defaultZoom}` }),
    ...(isOpeningHoursEnabled && { isOpeningHoursEnabled: `${isOpeningHoursEnabled}` }),
    ...(isOpeningHoursBreaksEnabled && { isOpeningHoursBreaksEnabled: `${isOpeningHoursBreaksEnabled}` }),
    ...(isAvailableDevicesEnabled && { isAvailableDevicesEnabled: `${isAvailableDevicesEnabled}` }),
    ...(isAvailableSticksEnabled && { isAvailableSticksEnabled: `${isAvailableSticksEnabled}` }),
    ...(isMultiBrandSticksEnabled && { isMultiBrandSticksEnabled: `${isMultiBrandSticksEnabled}` }),
    ...(isGeneralAnnouncementEnabled && { isGeneralAnnouncementEnabled: `${isGeneralAnnouncementEnabled}` }),
    ...(isAvailableServicesEnabled && { isAvailableServicesEnabled: `${isAvailableServicesEnabled}` }),
    ...(isStoreTypeEnabled && { isStoreTypeEnabled: `${isStoreTypeEnabled}` }),
    ...(isVendingMachineEnabled && { isVendingMachineEnabled: `${isVendingMachineEnabled}` }),
    ...(isVendingMachineTipEnabled && { isVendingMachineTipEnabled: `${isVendingMachineTipEnabled}` }),
    ...(isNearbyShopsEnabled && { isNearbyShopsEnabled: `${isNearbyShopsEnabled}` }),
    ...(isAsianAddressFormatEnabled && { isAsianAddressFormatEnabled: `${isAsianAddressFormatEnabled}` }),
  };
  const searchParams = new URLSearchParams();
  Object.entries(storeDetailsExtendedParams || {}).forEach(([key, value]) => {
    searchParams.append(key, value);
  });

  return `${storeDetailsPage}?${searchParams.toString()}`;
};
